var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 28,
    viewBox: "0 0 9 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85355 27.2032C4.65829 27.3984 4.34171 27.3984 4.14645 27.2032L0.964467 24.0212C0.769205 23.8259 0.769205 23.5093 0.964467 23.3141C1.15973 23.1188 1.47631 23.1188 1.67157 23.3141L4.5 26.1425L7.32843 23.3141C7.52369 23.1188 7.84027 23.1188 8.03553 23.3141C8.2308 23.5093 8.2308 23.8259 8.03553 24.0212L4.85355 27.2032ZM4.5 0.5L5 0.5L5 26.8496L4.5 26.8496L4 26.8496L4 0.5L4.5 0.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.36de3426bb1343993da5a28e58410c13.svg";
export { ForwardRef as ReactComponent };